(() => {
  'use strict';

  const TAB_SELECTOR = '[data-conguitos-menu-tab]';
  const PANEL_SELECTOR = '[data-conguitos-menu-panel]';
  const PROMO_SELECTOR = '[data-conguitos-menu-promo]';
  const SUBMENU_SELECTOR = '[data-conguitos-submenu]';
  const WIDE_DRAWER_QUERY = window.matchMedia('(min-width: 540px)');

  function submenuTrigger(drawer, submenu) {
    if (!drawer || !submenu.id) return null;
    return drawer.querySelector(`[aria-controls="${CSS.escape(submenu.id)}"]`);
  }

  function closeSubmenu(submenu, restoreFocus = false, immediately = false) {
    if (!submenu) return;

    const drawer = submenu.closest('.conguitos-menu-drawer');
    const panels = submenu.closest('.conguitos-menu-drawer__panels');
    const trigger = submenuTrigger(drawer, submenu);
    const closeImmediately = immediately || !WIDE_DRAWER_QUERY.matches;

    window.clearTimeout(submenu.conguitosCloseTimer);
    submenu.classList.remove('is-open');
    if (trigger) trigger.setAttribute('aria-expanded', 'false');

    if (closeImmediately) {
      submenu.hidden = true;
      panels?.classList.remove('has-open-submenu');
    } else {
      submenu.conguitosCloseTimer = window.setTimeout(() => {
        if (!submenu.classList.contains('is-open')) {
          submenu.hidden = true;
          panels?.classList.remove('has-open-submenu');
        }
      }, 230);
    }

    if (restoreFocus && trigger) trigger.focus();
  }

  function closeAllSubmenus(drawer, immediately = true) {
    drawer.querySelectorAll(SUBMENU_SELECTOR).forEach((submenu) => {
      closeSubmenu(submenu, false, immediately);
    });
  }

  function openSubmenu(trigger, moveFocus = true) {
    const drawer = trigger.closest('.conguitos-menu-drawer');
    if (!drawer) return;

    const submenuId = trigger.getAttribute('aria-controls');
    const submenu = submenuId ? drawer.querySelector(`#${CSS.escape(submenuId)}`) : null;
    if (!submenu) return;

    if (trigger.getAttribute('aria-expanded') === 'true') {
      closeSubmenu(submenu, true);
      return;
    }

    closeAllSubmenus(drawer, true);
    window.clearTimeout(submenu.conguitosCloseTimer);
    submenu.hidden = false;
    trigger.setAttribute('aria-expanded', 'true');
    const panels = submenu.closest('.conguitos-menu-drawer__panels');
    panels?.classList.add('has-open-submenu');
    if (panels) panels.scrollTop = 0;

    window.requestAnimationFrame(() => {
      submenu.classList.add('is-open');
      if (moveFocus) {
        const focusTarget = WIDE_DRAWER_QUERY.matches
          ? submenu.querySelector('.conguitos-menu-drawer__submenu-title')
          : submenu.querySelector('[data-conguitos-submenu-back]');
        focusTarget?.focus();
      }
    });
  }

  function activateTab(tab, moveFocus = false) {
    const drawer = tab.closest('.conguitos-menu-drawer');
    if (!drawer) return;

    const panelId = tab.getAttribute('aria-controls');
    const promoId = tab.dataset.conguitosPromoControls;
    const selectedPanel = panelId ? drawer.querySelector(`#${CSS.escape(panelId)}`) : null;
    const selectedPromo = promoId ? drawer.querySelector(`#${CSS.escape(promoId)}`) : null;
    if (!selectedPanel) return;

    closeAllSubmenus(drawer, true);

    drawer.querySelectorAll(TAB_SELECTOR).forEach((candidate) => {
      const active = candidate === tab;
      candidate.classList.toggle('is-active', active);
      candidate.setAttribute('aria-selected', active ? 'true' : 'false');
      candidate.tabIndex = active ? 0 : -1;
    });

    drawer.querySelectorAll(PANEL_SELECTOR).forEach((panel) => {
      const active = panel === selectedPanel;
      panel.classList.toggle('is-active', active);
      panel.hidden = !active;
    });

    drawer.querySelectorAll(PROMO_SELECTOR).forEach((promo) => {
      const active = promo === selectedPromo;
      promo.classList.toggle('is-active', active);
      promo.hidden = !active;
    });

    const panels = drawer.querySelector('.conguitos-menu-drawer__panels');
    if (panels) panels.scrollTop = 0;

    if (moveFocus) tab.focus();
  }

  document.addEventListener('click', (event) => {
    const submenuOpen = event.target.closest('[data-conguitos-submenu-open]');
    if (submenuOpen) {
      event.preventDefault();
      openSubmenu(submenuOpen);
      return;
    }

    const submenuBack = event.target.closest('[data-conguitos-submenu-back]');
    if (submenuBack) {
      event.preventDefault();
      closeSubmenu(submenuBack.closest(SUBMENU_SELECTOR), true);
      return;
    }

    const tab = event.target.closest(TAB_SELECTOR);
    if (!tab) return;

    event.preventDefault();
    activateTab(tab);
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') {
      const submenu = event.target.closest(SUBMENU_SELECTOR);
      if (submenu?.classList.contains('is-open')) {
        event.preventDefault();
        event.stopImmediatePropagation();
        closeSubmenu(submenu, true);
        return;
      }
    }

    const tab = event.target.closest(TAB_SELECTOR);
    if (!tab) return;

    const tablist = tab.closest('[role="tablist"]');
    if (!tablist) return;

    const tabs = Array.from(tablist.querySelectorAll(TAB_SELECTOR));
    const currentIndex = tabs.indexOf(tab);
    let nextIndex = currentIndex;

    switch (event.key) {
      case 'ArrowRight':
        nextIndex = (currentIndex + 1) % tabs.length;
        break;
      case 'ArrowLeft':
        nextIndex = (currentIndex - 1 + tabs.length) % tabs.length;
        break;
      case 'Home':
        nextIndex = 0;
        break;
      case 'End':
        nextIndex = tabs.length - 1;
        break;
      default:
        return;
    }

    event.preventDefault();
    activateTab(tabs[nextIndex], true);
  }, true);

  WIDE_DRAWER_QUERY.addEventListener('change', () => {
    document.querySelectorAll('.conguitos-menu-drawer').forEach((drawer) => {
      closeAllSubmenus(drawer, true);
    });
  });
})();
